import { render, staticRenderFns } from "./PromiseGoodsList.vue?vue&type=template&id=51a8db63"
import script from "./PromiseGoodsList.vue?vue&type=script&lang=js"
export * from "./PromiseGoodsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports